import React from "react";

const MainDetailsPage = () => {
  return (
    <div className="">
      <div className=" md:mt-[10%] lg:mt-[7%] xl:mt-[5%] mt-[10%]">
        <h1 className="text-white md:text-4xl lg:text-5xl text-[1.7rem] font-semibold text-center md:px-20 xl:px-48 px-12 lg:leading-normal md:leading-relaxed leading-loose">
          Discover Exciting Events Happening Near You - Stay Tuned for Updates!
        </h1>
        <p className="text-white max-md:leading-loose text-center md:px-40 xl:px-72 px-10 py-5">
          Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          vulputate libero et velit interdium, ac aliquet odio mattis. Class
          aptent taciti sociosqu ad litora torquent per conubia nostra, per
        </p>
      </div>
    </div>
  );
};

export default MainDetailsPage;
